export const checarSessao = () => {
  let expirada = false;
  let minutos = 0;
  /**
   *
   */
  let token_exp = localStorage.getItem("token_exp");
  if (token_exp) {
    let agora = new Date();
    token_exp = new Date(token_exp);

    minutos = (agora - token_exp) / (1000 * 60);

    if (minutos >= 30) {
      expirada = true;
    }
  } else {
    expirada = true;
  }

  if (expirada) {
    console.info("[SESSÃO] Sessão do navegador expirada, saindo...");
  } else {
    console.info(`[SESSÃO] Sessão ativa a ${minutos.toFixed(2)} minutos.`);
  }

  return expirada;
};

export const encerrar = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("token_exp");
  localStorage.removeItem("api_key");
  localStorage.removeItem("asaas_id_revenda");
  localStorage.removeItem("block");
  /**
   *
   */
  window.location.href = "/";
};

export const verificarSessao = async (callback) => {
  const expirou = checarSessao();
  if (expirou) {
    return encerrar();
  }

  if (typeof callback === "function") {
    return await callback();
  }
};

export const getMes = (opc) => {
  const data_atual = new Date();

  if (opc) {
    data_atual.setMonth(data_atual.getMonth() + opc);
  }

  const mes_retorno = data_atual.getMonth() + 1;

  return `${mes_retorno}`.padStart(2, 0);
};

export const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  });
}

export const apenasNumeros = (valor) => {
  return String(valor || "").replace(/\D/g, "");
};

export const mascararTelefone = (valor) => {
  const d = apenasNumeros(valor).slice(0, 11);
  let saida = "";
  if (d.length > 0) saida = "(" + d.substring(0, 2);
  if (d.length >= 3) saida += ") " + d.substring(2, 3);
  if (d.length >= 4) saida += " " + d.substring(3, 7);
  if (d.length >= 8) saida += "-" + d.substring(7, 11);
  return saida;
};